import React, { useEffect, useState } from 'react';
import { UserCircle} from "lucide-react";
import useAuth from "@/hooks/useAuth"; // Import the auth hook

interface User {
  name?: string;
  email?: string;
  avatarUrl?: string;
  // Add other possible auth user properties
  first_name?: string;
  last_name?: string;
  photo_url?: string;
  role?: string;
}

interface Props {
  user?: User; // Make optional since we can get from auth
  className?: string;
  showInfo?: boolean;
  useAuthState?: boolean; // New prop to use auth state instead of passed user
}

export const UserAvatarProfile: React.FC<Props> = ({
  user: passedUser,
  className = '',
  showInfo = false,
  useAuthState = true // Default to using auth state
}) => {
  const auth = useAuth();
  const [, forceUpdate] = useState({});

  // Use auth user if useAuthState is true, otherwise use passed user
  const user = useAuthState ? auth?.user : passedUser;

  // Force re-render when auth user changes
  useEffect(() => {
    if (useAuthState && auth?.user) {
      console.log('🔄 UserAvatarProfile detected auth user change:', auth.user);
      forceUpdate({});
    }
  }, [auth?.user?.name, auth?.user?.email, auth?.user?.role, useAuthState]);

  // Helper function to get display name
  const getDisplayName = () => {
    if (user?.name) return user.name;
    if (user?.email) return user.email.split('@')[0]; // Use email username as fallback
    return 'User';
  };

  // Helper function to get display email
  const getDisplayEmail = () => {
    return user?.email || 'No email';
  };

  // Debug: Log what user data we're receiving
  console.log('👤 UserAvatarProfile received user:', {
    user,
    useAuthState,
    authUser: auth?.user
  });

  if (!user) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <UserCircle className="h-8 w-8 rounded-full"/>
        {showInfo && (
          <div className="text-sm">
            <p className="font-medium">Loading...</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <UserCircle className="h-8 w-8 rounded-full"/>

      {showInfo && (
        <div className="text-sm">
          <p className="font-medium">{getDisplayName()}</p>
          <p className="text-muted-foreground">{getDisplayEmail()}</p>
          
        </div>
      )}
    </div>
  );
};